import { useState } from 'react'
import { Input, Typography } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { DataTable } from '@kolab/dms-base/components/ui'
import { PageLayout } from '@kolab/dms-base/components/layout'
import { listExpiringDevices } from '../../api/report.api'
import { reportKeys } from '../../api/queryKeys'
import type { ExpiringDevice } from '../../api/types'
import { StatusBadge } from '../../components/common/StatusBadge'
import { useCursorList } from '../../hooks/useCursorList'
import { CursorListStateView } from '../../components/common/QueryStateView'

const { Text } = Typography

export default function ExpiringDevicesReport() {
  const [asOf, setAsOf] = useState<string>('')

  const { items, isLoading, isError, error, refetch, isFetchingNextPage, hasNextPage, fetchNextPage } = useCursorList<ExpiringDevice>({
    queryKey: reportKeys.expiring.list({ pageSize: 20, asOf: asOf || undefined }),
    queryFn: (params) => listExpiringDevices(params),
    params: { asOf: asOf || undefined },
    pageSize: 20,
  })

  const columns: ColumnsType<ExpiringDevice> = [
    { title: 'Device identifier', dataIndex: 'deviceIdentifier', key: 'deviceIdentifier' },
    { title: 'Reseller', dataIndex: 'resellerName', key: 'resellerName' },
    { title: 'Distributor', dataIndex: 'distributorName', key: 'distributorName' },
    { title: 'Expiry', dataIndex: 'deviceExpiryDate', key: 'deviceExpiryDate' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s: string) => <StatusBadge status={s} /> },
  ]

  return (
    <PageLayout
      filters={
        <>
          <Text>As of:</Text>
          <Input
            placeholder="YYYY-MM-DD (empty = today)"
            style={{ width: 220 }}
            value={asOf}
            onChange={(e) => setAsOf(e.target.value)}
          />
        </>
      }
    >
      <CursorListStateView isLoading={isLoading} isError={isError} error={error} refetch={refetch}>
        <DataTable<ExpiringDevice>
          rowKey="id"
          columns={columns}
          dataSource={items}
          pagination={false}
          infiniteScroll={{ isFetchingNextPage, hasNextPage, fetchNextPage }}
        />
      </CursorListStateView>
    </PageLayout>
  )
}
